/**
 * @module components/Feedback/AlertError
 * @author Charles Blais <charles.blais@canada.ca>
 */

import React from 'react';
import { Alert } from 'react-bootstrap';

import { useLanguageState } from '../../contexts/language-state-provider';

/**
 * React component
 * ===============
 */
const AlertError = () => {
  const [ lang ] = useLanguageState();
  return (
    <Alert bsStyle='danger'>
      <p><strong>{lang.feedback.error}</strong> {lang.feedback.errorDetails}</p>
    </Alert>
  );
}

export default AlertError;